import {call, put, takeLatest, select} from 'redux-saga/effects';
import eulaActions from '../actions/eula.actions';
import EulaApi from '../api/EulaApi';
import {getLocale} from 'epic-common/src/locale';
import {getAffiliateAgreement, getConductAgreement} from '../selectors/eula.selectors';

function* acceptAgreements() {
    try {
        const params = yield select(getAffiliateAgreement);
        const data = {eula: params};

        yield call(EulaApi.acceptAffiliateAgreement, data);

        // TODO: Not supported yet
        const codeOfConduct = yield select(getConductAgreement);
        const codeOfConductData = {eula: codeOfConduct};
        yield call(EulaApi.acceptCodeOfConduct, codeOfConductData);
    } catch (e) {
        console.error('error accepting agreements:', e.message);
    }
}

function* fetchAffiliateAgreement() {
    try {
        const params = {
            locale: getLocale()
        };
        const response = yield call(EulaApi.getAffiliateAgreement, params);
        yield put(eulaActions.getAffiliateAgreementSuccess(response));
    } catch (e) {
        console.error('error fetching affiliate agreement', e.message);
        yield put(eulaActions.getAffiliateAgreementFailed(e));
    }
}

function* fetchConductAgreement() {
    try {
        const params = {
            locale: getLocale()
        };
        const response = yield call(EulaApi.getCodeOfConduct, params);
        yield put(eulaActions.getConductAgreementSuccess(response));
    } catch (e) {
        console.error('error fetching code of conduct agreement', e.message);
        yield put(eulaActions.getConductAgreementFailed(e));
    }
}

function* eulaSaga() {
    yield takeLatest(eulaActions.TYPES.ACCEPT_AGREEMENTS, acceptAgreements);
    yield takeLatest(eulaActions.TYPES.GET_AFFILIATE_AGREEMENT, fetchAffiliateAgreement);
    yield takeLatest(eulaActions.TYPES.GET_CONDUCT_AGREEMENT, fetchConductAgreement);
}

export default eulaSaga;
